import { render, staticRenderFns } from "./ComTableHis.vue?vue&type=template&id=98ac7e80&scoped=true&"
import script from "./ComTableHis.vue?vue&type=script&lang=js&"
export * from "./ComTableHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ac7e80",
  null
  
)

export default component.exports